import { gql } from "@apollo/client";
import { PageContentStack } from "atoms/Stack";
import Stack from "atoms/Stack";
import { MAX_CONTENT_WIDTH } from "helpers/breakpoints";
import { gaSetSharedEventParams } from "helpers/gtag";
import { SPACING } from "helpers/spacings";
import useData from "helpers/useData";
import useEnforceAuth from "helpers/useEnforceAuth";
import React from "react";
import NotFoundPage from "shared/NotFoundPage";
import { PersonPageTitle } from "shared/PageTitle";

import PersonCareerStats from "./person/PersonCareerStats";
import PersonGamesStats from "./person/PersonGamesStats";
import PersonPagesHeader from "./person/PersonPagesHeader";

export default function PersonPage({ personId }) {
  useEnforceAuth({ enforceAuthenticated: true });
  const [data] = useData(
    gql`
      query PersonPage($personId: ID!) {
        person(id: $personId) {
          id
          org {
            id
            gaId
          }
        }
      }
    `,
    { personId },
  );
  gaSetSharedEventParams({ org_id: data?.person?.org?.gaId });

  if (data && !data.person) return <NotFoundPage />;

  return (
    <>
      <PersonPageTitle />
      <PersonPagesHeader personId={personId} tab="profile" />
      <PageContentStack>
        <Stack style={{ margin: "0 auto", maxWidth: MAX_CONTENT_WIDTH, width: `calc(100vw - ${SPACING} * 2)` }}>
          <PersonCareerStats personId={personId} />
          <PersonGamesStats personId={personId} />
        </Stack>
      </PageContentStack>
    </>
  );
}
